import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SliderInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Sliderstyled__SliderInput",
  componentId: "sc-xg7ss4-0"
})(function (props) {
  // TODO: ADSWEB-1096 Outline instantly disappears on thumb defocus
  var thumbStyles = {
    appearance: 'none',
    pointerEvents: props.$disabled ? 'none' : 'all',
    userSelect: 'none',
    cursor: props.$disabled ? undefined : 'pointer',
    outlineColor: 'transparent',
    transition: 'background-color 0.2s ease-in-out, outline-color 0.2s ease-in-out',
    width: props.$thumbStyles.size,
    height: props.$thumbStyles.size,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: props.$thumbStyles.borderWidth,
    borderColor: props.$thumbStyles.borderColor,
    backgroundColor: props.$thumbStyles.backgroundColor,
    boxShadow: props.$thumbStyles.boxShadow
  };
  return _objectSpread({
    appearance: 'none',
    pointerEvents: props.$pointerEvents,
    cursor: props.$disabled ? undefined : 'pointer',
    position: 'absolute',
    background: props.$background,
    backgroundColor: props.$backgroundColor,
    borderRadius: '999px',
    width: '100%',
    margin: 0,
    padding: 0,
    border: 0,
    height: props.$isSecondary ? 0 : '4px',
    zIndex: props.$isSecondary ? 1 : undefined,
    '&::-webkit-slider-thumb': thumbStyles,
    '&::-moz-range-thumb': thumbStyles,
    '&:focus': {
      outline: 'none'
    },
    // Increase touch area of the slider
    '&::before': {
      content: '""',
      position: 'absolute',
      top: props.$touchAreaOffset,
      bottom: props.$touchAreaOffset,
      left: 0,
      right: 0
    }
  }, props.$interactiveState);
});

export { SliderInput };
//# sourceMappingURL=Slider.styled.js.map
